import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useBannerActions } from 'src/hooks/useBannerActions';
import { useGameAction } from 'src/hooks/useGameAction';
import { CmsCta, CmsRelation } from 'src/types/cms/cmsFieldTypes';
import { CmsActionGrid } from 'src/types/cms/cmsWidgetTypes';
import { RootState } from 'src/types/store-types';
import Template_1_3 from './components/Template_1_3';
import Template_2_3 from './components/Template_2_3';
import Template_3_1 from './components/Template_3_1';
import Template_4 from './components/Template_4';
import './styles.scss';

const HomeWidgets: FC<{ homeWidgetsData?: CmsRelation<CmsActionGrid> | null; settings: any }> = ({
  homeWidgetsData,
  settings,
}) => {
  const [tagList, setTagList] = useState<any[]>([]);
  const { styles, type } = settings;

  const { tags } = useSelector((state: RootState) => state.games);

  const { categoriesData } = useSelector((state: RootState) => state.configs);
  const { selectedCategory } = useSelector((state: RootState) => state.app);
  const { providerAction, loginAction, registrAction, promotionAction, categoryAction, externalUrlAction } =
    useBannerActions();

  const { handleActionGame } = useGameAction();

  const redirect = (action?: CmsCta): any => {
    switch (action?.variant) {
      case 'goToRegister':
        registrAction();
        break;
      case 'goToLogin':
        loginAction();
        break;
      case 'goToPromotion':
        promotionAction(action?.param);
        break;
      case 'goToProvider':
        providerAction({ provider: action?.param, tags: tags, tagList: tagList });
        break;
      case 'goToExternalUrl':
        externalUrlAction(action?.param);
        break;
      case 'goToGame':
        handleActionGame(action?.param as number);
        break;
      case 'goToCategory':
        categoryAction(action?.param);
        break;
      case 'goToRace':
      case 'noAction':
        break;
      default:
        return;
    }
  };

  const widgetTemplate = (): JSX.Element => {
    let template;

    switch (type) {
      case 'home_widget_template_2-3':
        template = <Template_2_3 widget={homeWidgetsData?.[0]?.relation} redirect={redirect} />;
        break;
      case 'home_widget_template_3-1':
        template = <Template_3_1 widget={homeWidgetsData?.[0]?.relation} redirect={redirect} />;
        break;
      case 'home_widget_template_1-3':
        template = <Template_1_3 widget={homeWidgetsData?.[0]?.relation} redirect={redirect} />;
        break;
      case 'home_widget_template_4':
        template = <Template_4 widget={homeWidgetsData?.[0]?.relation} redirect={redirect} />;
        break;
      default:
        template = <Template_2_3 widget={homeWidgetsData?.[0]?.relation} redirect={redirect} />;
    }

    return template;
  };

  useEffect(() => {
    categoriesData &&
      setTagList(categoriesData[selectedCategory]?.tags?.filter((f) => f.tagName === 'allGames')?.[0].tagGames || []);
  }, [categoriesData]);

  return (
    <div className={type} style={styles}>
      {widgetTemplate()}
    </div>
  );
};
export default HomeWidgets;
